// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1xj6U","left":"StickyBox_left__3Ij4c","right":"StickyBox_right__2eu-h"};